import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import PizzeriaDashboard from "@/pages/dashboard/PizzeriaDashboard";
import ClientDashboard from "@/pages/dashboard/ClientDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (user.role === "admin") return <AdminDashboard user={user} />;
  if (user.role === "pizzeria") return <PizzeriaDashboard user={user} />;
  return <ClientDashboard user={user} />;
}
